import React, { Component } from "react";
import Seo from './Seo';
import { FaLaptopCode, FaChalkboardTeacher, FaBriefcase } from "react-icons/fa";
import '../css/services.css';
import { withTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

class ServicesAmeliorated extends Component {
  state = {
    selectedService: null, // Indicator of the selected service
    redirectToContactUs: false
  };

  

  selectService = (index) => {
    const { selectedService } = this.state;
    if (selectedService === index) {
      this.setState({ selectedService: null });
      const element = document.getElementById("services-grid");
      element?.scrollIntoView({ behavior: "smooth", block: "start" }); // Scroll to the top of the section
    } else {
      this.setState({ selectedService: index });
      const element = document.getElementById("corps");
      element?.scrollIntoView({ behavior: "smooth", block: "start" }); // Scroll to the top of the details
    }
  };
  
  redirectToContactUs=() =>{
    this.setState({redirectToContactUs: true});
  }

  render() {
    const {t} = this.props;
    const services = t("services",{ returnObjects: true});

    if(this.state.redirectToContactUs){
      return <Navigate to="/contactUs" />;
    }
    return (
      <div className="services-container min-h-screen bg-gray-100 text-gray-900">
        <Seo
          title="Services"
          description="Conseil, développement et formation IT : Java, Spring, Angular, React et WordPress — des solutions sur mesure pour votre entreprise."
          path="/services"
        />
        {/* Hero Section */}
        <div className="relative bg-cover bg-center h-[50vh] flex items-center justify-center text-white"
          style={{ backgroundImage: `url('/services-bg.jpg')` }}>
          <div className="absolute inset-0 bg-black/60"></div>
          <h1 className="text-4xl font-bold relative z-10">{t('our_services')}</h1>
        </div>

        {/* Services Section */}
        <div className="container mx-auto py-16 px-8">
          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" id="services-grid">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-3xl shadow-xl p-8 text-center hover:scale-105 transition-transform duration-300">
                <div className="mb-6">
                {index === 0 && <FaBriefcase className="text-blue-500 text-4xl" />}
                {index === 1 && <FaLaptopCode className="text-green-500 text-4xl" />}
                {index === 2 && <FaChalkboardTeacher className="text-yellow-500 text-4xl" />}
                </div>
                <h3 className="text-2xl font-semibold text-blue-600 mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <p className="text-gray-500 text-sm mb-6">{service.details}</p>

                {/* En savoir plus button */}
                <div 
  onClick={() => this.selectService(index)}
  className={`service-button ${this.state.selectedService === index ? 'active' : ''}`}
>
  {this.state.selectedService === index ? t('see_less') : t('learn_more')}
</div>
              </div>
            ))}
          </div>
        </div>

        {/* Selected Service Details Section */}
        <div id="service-details" className="container mx-auto py-16 px-8">
          {this.state.selectedService !== null && (
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <h2 className="text-3xl font-semibold text-blue-600 mb-4">{services[this.state.selectedService].title}</h2>

              {/* Display image based on selected service */}
                    <div id="corps">
                    {this.state.selectedService === 0 && (
                <img src='/coworking.jpg' alt="Mission chez le client" className="w-full rounded-lg mb-6" />
              )}
              {this.state.selectedService === 1 && (
                <img src='/remote.jpg' alt="Prestations à distance" className="w-full rounded-lg mb-6" />
              )}

              <p className="text-gray-600 mb-6">{services[this.state.selectedService].details}</p>

              {/* Display courses if available */}
              {services[this.state.selectedService].courses && (
                <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">
                  {services[this.state.selectedService].courses.map((course, courseIndex) => (
                    <div key={courseIndex} className="bg-white p-8 rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105">
                      <h3 className="text-xl font-semibold text-blue-500 mb-4">{course.title}</h3>
                      <p className="text-gray-700 mb-4">{course.description}</p>
                      <p className="text-gray-500 text-sm mb-2">{t('duration')}: {course.duration}</p>
                      <p className="text-gray-600 font-semibold">Technologies:</p>
                      <ul className="text-gray-500 text-sm">
                        {course.technologies.map((tech, index) => (
                          <li key={index}>{tech}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
                    </div>
            </div>
          )}
        </div>

        {/* Contact Button */}
        <div className="text-center mt-16" style={{marginBottom : '30px'}}>
          <div  onClick={() => this.redirectToContactUs()}
          className="contact-button">
           {t('contact_us')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ServicesAmeliorated);
